import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import CreateLinkPrompt from 'documents-ui/components/createLink/CreateLinkPrompt';
import SummaryEmptyTable from './SummaryEmptyTable';
import { DocumentsIcon } from 'foundations-assets/icons/components/DocumentsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SummaryRecipientsZeroState = ({
  gdprSettings,
  deckId,
  name
}) => {
  const {
    showCreateLinkModal,
    renderCreateLinkModal
  } = CreateLinkPrompt({
    deckId,
    name,
    gdprSettings
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(SummaryEmptyTable, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "SUMMARY_LOAD"
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        padding: "1000",
        children: [/*#__PURE__*/_jsx(View, {
          marginBlock: "600",
          children: /*#__PURE__*/_jsx(DocumentsIcon, {
            size: "1300",
            color: "do-not-use-flint"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "summary.zeroState.title"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "small",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "summary.zeroState.subText"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: showCreateLinkModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "summary.zeroState.createLink"
          })
        })]
      })]
    }), renderCreateLinkModal()]
  });
};
export default SummaryRecipientsZeroState;